import PropTypes from 'prop-types'
import React from 'react'
import { useSessionStorage } from 'react-use'

import { NEWSLETTER_SUBSCRIPTION_KEY } from '../../utils/sessionStorageConstants'

import NewsletterSubscriptionPopup from './NewsletterSubscriptionPopup'

export const NewsletterSubscription = ({
  iframe_height: iframeHeight, iframe_url: iframeUrl, newsletter_id: newsletterId, form_name: formName
}) => {
  const [wasNewsletterSeen, setWasNewsletterSeen] = useSessionStorage(NEWSLETTER_SUBSCRIPTION_KEY(newsletterId), false)

  return !wasNewsletterSeen && (
    <NewsletterSubscriptionPopup
      iframeUrl={iframeUrl}
      iframeHeight={iframeHeight}
      formName={formName}
      markNewsletterSeen={() => setWasNewsletterSeen(true)}
    />
  )
}

NewsletterSubscription.propTypes = {
  newsletter_id: PropTypes.string.isRequired,
  iframe_url: PropTypes.string.isRequired,
  iframe_height: PropTypes.string.isRequired,
  form_name: PropTypes.string.isRequired
}

export default NewsletterSubscription
